import upperFirst from 'lodash/upperFirst'

export default function(value) {
  return !value ? '' : upperFirst(value.toString())
}
